import React from 'react';

export const Overview = ({ QnLength, item }) => {
  const question = [];
  const currentindex = item?.index;
  const isanswered = item?.answer ? true : false;

  if (QnLength) {
    for (let i = 0; i < QnLength; i++) {
      question.push(
        <div
          className={
            'indicatormain ' +
            (currentindex > i || (isanswered && currentindex == i) ? 'answered' : '')
          }
          key={i}
        >
          {i + 1}
        </div>,
      );
    }
  }
  return (
    <div className='overview'>
      <div className='overviewbox'>
        <div className='overviewheader'>
          {false && (
            <div>
              <div className='topicname'>Arabic Prose and Poetry</div>
              <div className='d-flex justify-content-center gap-2'>
                <div className='descitem'>
                  <img src='/img/question_icon.png' className='desc_icon' /> 10 Questions
                </div>
                <div className='examlabel'>Practice</div>
              </div>
            </div>
          )}
          <div className='topicname'>Review</div>
          <div className='d-flex gap-5 mt-3 mb-3'>
            <div className='indicatorlabel'>
              <div className='indicator answered'></div>
              Answered
            </div>
          </div>
          <div className='overviewcontent'>
            {/* {questions?.map((item, index) => {
              return (
                
              );
            })} */}
            {question}
          </div>
        </div>
      </div>
    </div>
  );
};
